<div id="printArea" class="a5-page text-bold">
  <!-- Address Section -->
  <div class="card" *ngIf="this.billType != 'OFFLINE'">

    <!-- To Address (Start Side) -->
    <div class="to-address ms-3">
      <h2 class="mb-n1">To :</h2>
      <p class="mb-n1" *ngIf="billDetails?.customerName">{{ billDetails?.customerName }},</p>
      <p class="mb-n1" *ngIf="billDetails?.doorNo">{{ billDetails?.doorNo }},</p>
      <p class="mb-n1" *ngIf="billDetails?.street">{{ billDetails?.street }},</p>
      <p class="mb-n1" *ngIf="billDetails?.city">{{ billDetails?.city }},</p>
      <p class="mb-n1" *ngIf="billDetails?.pincode">{{ billDetails?.state }} - {{ billDetails?.pincode }},</p>
      <p class="mb-n1" *ngIf="billDetails?.phoneNumber">Ph: {{ billDetails?.phoneNumber }}</p>
    </div>

    <!-- Separator -->
    <hr>

    <!-- From Address (End Side) -->
    <div class="from-address text-end me-3">
      <h2 class="mb-n1">From :</h2>
      <p class="mb-n1">Athulya Agencies</p>
      <p class="mb-n1">64A, jayalakshmi nagar 2nd street,</p>
      <p class="mb-n1">kk nagar, Trichy - 620021</p>
      <p class="mb-n1">Ph: 87608 49004</p>
    </div>
  </div>


  <!-- Invoice Table -->
  <div class="disclaimer">
    <div class="row mt-2" *ngIf="this.billType != 'OFFLINE'"></div>
    <div class="invoice-section mt-3">
      <table class="disclaimer">
        <thead>
          <tr>
            <th colspan="6" class="text-center">
              <div class="invoice-header">
                <img src="../../../assets/img/new/athulya-agencies.png" class="logo">
                <div class="company-info">
                  <!-- <h2 class="company-name">Athulya Agencies</h2> -->
                  <p class="mb-n2">64A, jayalakshmi nagar 2nd street, kk nagar, Trichy - 620021</p>
                  <p class="mb-n2">ph:+91 87608 49004</p>
                  <p class="mb-n2"><i class="bi bi-instagram"></i>_.lovely__fashion._ <span class="ms-4"></span><i
                      class="bi bi-youtube"></i>Lovely Fashion Madurai</p>
                </div>
              </div>
            </th>
          </tr>

          <tr *ngIf="billType == 'OFFLINE'">
            <th colspan="6">
              <div class="d-flex align-items-start">
                <!-- <h2 class="text-bold me-3">Customer Details :</h2> -->
                <div class="d-flex flex-column">
                  <span class="text-start" *ngIf="billDetails?.customerName">{{ billDetails?.customerName }},</span>
                  <span class="text-start" *ngIf="billDetails?.phoneNumber">{{ billDetails?.phoneNumber }},</span>
                  <span class="text-start">{{ billDetails?.doorNo }} <span *ngIf="billDetails?.doorNo">,</span> {{
                    billDetails?.street }}
                    <span *ngIf="billDetails?.street">,</span> {{ billDetails?.city }},</span>
                  <span class="text-start">{{ billDetails?.state }} - {{ billDetails?.pincode }}</span>
                </div>
              </div>
            </th>
          </tr>

          <tr>
            <th>S.No</th>
            <th>Product Name</th>
            <th>Size</th>
            <th>Quantity</th>
            <th>Unit Price</th>
            <th>Amount (₹)</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of billDetails?.products; let i = index">
            <td>{{ i + 1 }}</td>
            <td>{{ item.productName }}</td>
            <td>{{ item.size }}</td>
            <td>{{ item.quantity }}</td>
            <td>{{ item.unitPrice }}</td>
            <td class="text-end">{{ item.quantity * item.unitPrice | currency:'INR' }}</td>
          </tr>
        </tbody>
        <tfoot>
          <tr>
            <td colspan="5" class="text-end pe-3"><strong>Total</strong></td>
            <td class="text-end"><strong>{{ (billDetails?.subTotal | currency:'INR') || "-"}}</strong></td>
          </tr>
          <tr>
            <td colspan="5" class="text-end pe-3"><strong>Discount (%)</strong></td>
            <td class="text-end"><strong>{{ (billDetails?.discount | currency:'INR') || '-' }}</strong></td>
          </tr>
          <tr>
            <td colspan="5" class="text-end pe-3"><strong>Final Amount</strong></td>
            <td class="text-end"><strong>{{ (billDetails?.totalAmount | currency:'INR') || '-' }}</strong></td>
          </tr>
        </tfoot>
      </table>
    </div>

    <div style="border-top: 1px solid transparent; padding: 3px;">
      <h3 class="mt-3 text-end disclaimer">Amount in words:
        <span class="dotted-underline text-bold"> {{numberToWords(billDetails?.totalAmount)}} Only</span>
      </h3>
    </div>

    <div class="row end-font">
      <h4 class="text-bold ">Disclaimer:</h4>
      <p class="mb-n2">This bill reflects the details of the textile purchase made by the customer.All items are sold
        as-is
        and are subject to the terms and conditions of sale.No returns or exchanges are allowed unless specified by
        store policy.
        Please review your purchase carefully; discrepancies must be reported within 1 day from the date of purchase.
      </p>
    </div>
  </div>

</div>

<footer class="fixed-footer">
  <h3 class="mb-0 text-bold">For Athulya Agencies</h3>
  <p class="mb-0 text-bold">{{this.getCurrentDate()}} - {{this.getCurrentTime()}}</p>
</footer>